import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom';
import * as ReactRouter from 'react-router';
import * as ReactRouterDOM from 'react-router-dom';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';

window.axios = axios;
// 解决#321
const parentDom = window.parent.document && window.parent.document.querySelector('[fieldid="approvedetail_iframe"],#ssc-bill-detail-iframe');
window.React = React;
if (parentDom && window.parent.React && window.React) {
    window.React = window.parent.React;
}
window.ReactDOM = ReactDOM;
if (parentDom && window.parent.ReactDOM && window.ReactDOM) {
    window.ReactDOM = window.parent.ReactDOM;
}
window.ReactRouter = ReactRouter;
window.ReactRouterDOM = ReactRouterDOM;
window.Redux = Redux;
window.ReactRedux = ReactRedux;

